import styled from "styled-components";
import YLLWLOGO from "../../assets/Yllw_Inventory.svg";
type Props = {
    heading?: string;
    subheading?: string;
};

export const InventoryHeader = (props: Props) => {
    return (
        <>
            <Logo src={YLLWLOGO} />
            <InventoryHeading>{props.heading}</InventoryHeading>
            <InventorySubHeading>{props.subheading}</InventorySubHeading>
        </>
    );
};

const InventoryHeading = styled.h3`
    color: #8c8c8c;
    margin-top: 0;
    margin-bottom: 0;
    font-family: "Poppins", sans-serif;
    font-size: 18;
`;

const InventorySubHeading = styled.h4`
    color: #8c8c8c;
    margin-top: 5px;
    margin-bottom: 0;
    font-family: "Poppins", sans-serif;
    font-size: 18;
`;
const Logo = styled.img`
    width: 120px;
    height: 22px;
    left: 135px;
    margin-top: 30px;
`;
